<div *ngIf="layout">
  <app-header></app-header>
</div>

<div class="pt-[6rem] md:pt-[6.5rem] lg:pt-[7.5rem] 3xl:pt-[9.8rem]">
  <router-outlet></router-outlet>
</div>

<router-outlet></router-outlet>

<div *ngIf="layout">
  <app-footer></app-footer>
</div>